/* eslint-disable indent */
import CONFIG from '../../globals/config';

const restoDetailTemplate = (resto) => `
<picture>
<source
  media="(max-width: 600px)"
  data-srcset="${CONFIG.BASE_SMALLIMAGE_URL + resto.pictureId}"
>
<img 
  src="./images/placeholder.webp"
  data-src="${
  CONFIG.BASE_LARGEIMAGE_URL + resto.pictureId
}" class="lazyload detail-img" alt="${resto.name}"/>
</picture>
    <div class="resto-detail">
        
        <h2 class="detail-title">${
          resto.name
        } <span class="rating">&nbsp&nbsp⭐️${resto.rating}</span></h2>
        <p class="content-loc">${resto.address},&nbsp${resto.city}</p>
        <p class="content-desc">${resto.description}</p>
        <div class="list-menu">
        <h3>Menu makanan:</h3>
        <ul id="listmakanan"></ul>
        </div>
        <div class="list-menu">
        <h3>Menu minuman:</h3>
        <ul id="listminuman"></ul>
        </div>
        <div class="container-review" id="reviews">
            <h3>Review Pengunjung:</h3>
        </div>
        <div class="container-postreview">
        <h3>Tambahkan Review</h3>
        <form id="review-form" class="review-form">
        <label for="nama" class="label-review">Nama:</label><br>
        <input type="text" id="nama" name="nama" class="input-review" required><br>
        <label for="review">Review anda:</label><br>
        <input type="text" id="review" name="review" class="input-review" required><br><br>
        <button type="submit" value="Submit" class="btn-submit">Submit</button>
      </form> 
        </div>
    </div>
`;

const restoItemTemplate = (item) => `
    <div class="item-content">
    <picture>
          <source  
            media="(max-width: 600px)"
            data-srcset="${CONFIG.BASE_SMALLIMAGE_URL + item.pictureId}"
          >
          <img data-src="${
            CONFIG.BASE_LARGEIMAGE_URL + item.pictureId
          }" class="lazyload content-img" alt="${item.name}"/>
        </picture>
        <div class="info-container">
            <h2 id="restaurant-title"><a href="/#/detail/${
              item.id
            }" class="content-title">${item.name}</a></h2>
            <p class="content-loc">${item.city} <span>&nbsp;&nbsp;&nbsp;⭐️${
  item.rating
}/5</span></p>
            <p class="content-desc">${item.description}</p>
        </div>

    </div>
`;

const createSkeletonRestoTemplate = (count) => {
  let template = '';

  for (let i = 0; i < count; i += 1) {
    template += `
      <div class="item-content">
        <img class="content-img" width="100%" height="200px" src="./images/placeholder.png" alt="skeleton">
        <div class="info-container">
          <h2 class="skeleton">Lorem ipsum dolor sit.</a></h2>
          <p class="skeleton">Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci alias aspernatur, assumenda aut consectetur consequuntur debitis deleniti dicta dolorem dolorum eos exercitationem labore laboriosam magni nihil, nobis obcaecati optio perspiciatis placeat qui recusandae saepe sapiente sequi totam ullam ut.</p>
        </div>
      </div>
    `;
  }
  return template;
};

const createLikeButtonTemplate = () => `
  <button aria-label="like this movie" id="likeButton" class="like">
    <i class="fa fa-heart-o" aria-hidden="true"></i>
  </button>
`;

const createLikedButtonTemplate = () => `
  <button aria-label="unlike this movie" id="unlikeButton" class="like">
    <i class="fa fa-heart" aria-hidden="true"></i>
  </button>
`;

export {
  restoDetailTemplate,
  restoItemTemplate,
  createLikeButtonTemplate,
  createLikedButtonTemplate,
  createSkeletonRestoTemplate,
};
